import {Component, HostListener, OnInit, ViewChild} from '@angular/core';
import {NgForm} from '@angular/forms';
import {ApiClientService} from '../../../services/api-client.service';
import {UrlService} from '../../../services/url.service';
import {ConstantsService} from '../../../services/constants.service';
import {ParkingPass, SettingsParkingRule} from '../../../types/data.types';
import {AuthenticationService} from '../../../services/authentication.service';
import {ParkingPassService} from '../../../services/parking-pass.service';

declare const toastr: any;
declare const $: any;
declare const swal: any;

@Component({
    selector: 'parking-pass-payment',
    templateUrl: './parking-pass-payment.component.html',
    styleUrls: ['./parking-pass-payment.component.scss']
})
export class ParkingPassPaymentComponent implements OnInit {
    @ViewChild('form') form;
    showModal = false;
    data: ParkingPass = new ParkingPass();
    disabledSubmit = false;
    availablePaymentMethods = [];
    rule = new SettingsParkingRule();
    spinnerShow = false;
    creditCardInfo = {
        cardHolderName: '',
        postalCode: '',
        creditCardNumber: '',
        cardMonth: '',
        cardYear: '',
        cvv: '',
        reservationFee: '',
        securityDeposit: ''
    };
    cardMonthArray:  Array<string> = ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'];
    cardYearsArray:  Array<number> = [];

    constructor(
        public api: ApiClientService,
        public parkingPassService: ParkingPassService,
        public authService: AuthenticationService,
        public urlService: UrlService
    ) {}

    ngOnInit() {
        this.initData();
        setTimeout( () => this.showModal = true, 300);
        this.urlService.modalOpened.emit();
    }

    initData() {
        this.data = JSON.parse(JSON.stringify(this.parkingPassService.parkingPassInParkingPassModal));
        const currentYear = new Date().getFullYear();
        for(let i = currentYear - 10; i < currentYear + 11; i++)
            this.cardYearsArray.push(i);
        if(this.data.parkingLot.parkingRule.acceptCash)
            this.availablePaymentMethods.push({value: 'cash', displayName: 'Cash'});
        if(this.data.parkingLot.parkingRule.acceptCheques)
            this.availablePaymentMethods.push({value: 'cheque', displayName: 'Cheque'});
        if(this.data.parkingLot.parkingRule.acceptCreditCards)
            this.availablePaymentMethods.push({value: 'credit_card', displayName: 'Credit Card'});
        if(this.data.parkingLot.parkingRule.defaultPaymentMethod)
            this.data.paymentMethod = this.data.parkingLot.parkingRule.defaultPaymentMethod;
        if(this.data.payment && this.data.payment.paymentMethod)
            this.data.paymentMethod = this.data.payment.paymentMethod;
    }

    hideModal() {
        if (this.form.dirty && this.form.touched) {
            swal(ConstantsService.getSwalConfig('Close without saving?', 'Do you want to delete unsaved data?'),
                () => {
                    this.parkingPassService.isPaymentModalShow = false;
                    this.parkingPassService.parkingPassInParkingPassModal = null;
                    this.urlService.modalClosed.emit();
                }
            );
        } else {
            this.parkingPassService.isPaymentModalShow = false;
            this.parkingPassService.parkingPassInParkingPassModal = null;
            this.urlService.modalClosed.emit();
        }
    }

    updateView(msg: string): void {
        toastr.success(msg);
        this.parkingPassService.getData();
        this.form.reset();
        this.hideModal();
    }

    getPaymentsFormatted(): any {
        return this.data.payment && this.data.paymentMethod ?
               {
                   status: this.data.payment.status ? 1 : 0,
                   paymentMethod: this.data.paymentMethod,
                   amount: this.data.payment.amount
               } :
               null;
    }

    onSubmit(form: NgForm) {
        if(!form.valid) {
            if(!this.data.paymentMethod) toastr.warning('Payment method should not be blank.');
                return;
        }

        const data = { payment: this.getPaymentsFormatted() };
        this.disabledSubmit = true;
        const url = `/v1/booking/${this.parkingPassService.parkingPassInParkingPassModal.id}.json`;
        this.parkingPassService.api.patch('domainParkingPass', url, data).subscribe(
            () => this.updateView('The Payment was successfully updated'),
            error => this.api.errorHandler(error, 'Update failed!'),
            () => this.disabledSubmit = false
        );
    }

    @HostListener('document:keydown.escape', ['$event']) onKeydownHandler(event: KeyboardEvent) {
        setTimeout(() => this.hideModal(), 100);
    }
}



// WEBPACK FOOTER //
// /app/src/app/views/parking-pass/parking-pass-payment/parking-pass-payment.component.ts